import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { IngressNote } from './entities';
import { UUID } from '@benzinga/session';
import { StockSymbol } from '@benzinga/session';
import { WatchlistId } from '@benzinga/watchlist-manager';
import { Session } from '@benzinga/session';
import { NotesEnvironment } from './environment';

export class NotesRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(NotesEnvironment).url, session);
  }

  getNotes = (): SafePromise<IngressNote[]> => {
    const url = this.URL('api/v1/watchlistnotes/');
    return this.debouncedGet(url, { includeHeader: { authorizationSession: true } });
  };

  createNote = (symbol: StockSymbol, text: string, watchlistid?: WatchlistId): SafePromise<IngressNote> => {
    const url = this.URL('api/v1/watchlistnotes/');
    return this.post(
      url,
      {
        symbol,
        text,
        watchlistid,
      },
      { includeHeader: { authorizationSession: true } },
    );
  };

  getNotesFiltered = (symbolOrUUID: StockSymbol | UUID): SafePromise<IngressNote[]> => {
    const url = this.URL(`api/v1/watchlistnotes/${symbolOrUUID}/`);
    return this.debouncedGet(url, { includeHeader: { authorizationSession: true } });
  };

  updateNote = (uuid: UUID, text: string): SafePromise<IngressNote> => {
    const url = this.URL(`api/v1/watchlistnote/${uuid}/`);
    return this.post(url, { text }, { includeHeader: { authorizationSession: true } });
  };

  deleteNote = async (uuid: UUID): SafePromise<undefined> => {
    const url = this.URL(`api/v1/watchlistnote/${uuid}/`);
    const deleted = await this.delete(url, { includeHeader: { authorizationSession: true } });
    if (deleted.err) {
      return { err: deleted.err };
    } else {
      return { ok: undefined };
    }
  };
}
